/* tslint:disable */
/* eslint-disable */
export enum PlanType {
    Greenfield = 'GREENFIELD',
    Renovation = 'RENOVATION',
    Extension = 'EXTENSION',
    Reconstruction = 'RECONSTRUCTION'
}
